if (!customElements.get('unlimited-plan-picker')) {
  customElements.define(
    'unlimited-plan-picker',
    class UnlimitedPlanPicker extends HTMLElement {
      connectedCallback() {
        this.radio = this.querySelector('input[type="radio"]');
        this.select = this.querySelector('[data-unlimited-days]');
        this.price = this.querySelector('[data-unlimited-price]');
        this.validity = this.querySelector('[data-unlimited-validity]');

        if (!this.radio || !this.select) return;

        const currentValue = this.dataset.currentValue;
        if (currentValue) this.select.value = currentValue;

        this.select.addEventListener('change', (event) => {
          event.stopPropagation();
          this.selectPlan(this.select.selectedOptions[0]);
        });

        const productInfo = this.closest('product-info');
        if (!productInfo || productInfo.dataset.eeInitialPlanSelectionApplied === 'true') return;

        productInfo.dataset.eeInitialPlanSelectionApplied = 'true';

        const firstAvailableOption = Array.from(this.select.options).find((option) => !option.disabled);
        if (!firstAvailableOption) return;

        const firstPlanIsAlreadySelected = this.radio.checked && this.radio.value === firstAvailableOption.value;
        if (firstPlanIsAlreadySelected) return;

        this.select.value = firstAvailableOption.value;
        this.selectPlan(firstAvailableOption);
      }

      selectPlan(selectedOption) {
        if (!selectedOption) return;

        this.radio.value = selectedOption.value;
        this.radio.dataset.optionValueId = selectedOption.dataset.optionValueId;
        this.radio.dataset.productUrl = selectedOption.dataset.productUrl || '';
        this.radio.checked = true;

        if (this.price) {
          const now = this.price.querySelector('[data-unlimited-price-now]');
          const was = this.price.querySelector('[data-unlimited-price-was]');
          const code = this.querySelector('[data-unlimited-sale-code]');
          if (now && was && code) {
            now.textContent = selectedOption.dataset.price || '';
            was.textContent = selectedOption.dataset.priceWas || '';
            was.hidden = !selectedOption.dataset.priceWas;
            code.textContent = selectedOption.dataset.saleCode ? selectedOption.dataset.saleMessage : '';
            code.hidden = !selectedOption.dataset.saleCode;
          } else {
            this.price.textContent = selectedOption.dataset.price || '';
          }
        }

        if (this.validity) {
          const days = Number(selectedOption.dataset.days || 0);
          this.validity.textContent = `${days} ${days === 1 ? 'day' : 'days'} validity`;
        }

        this.radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
